import { configureStore } from '@reduxjs/toolkit'
import authReducer from './Slices/auth'
import productsReducer from './Slices/productSlice'
import blogsReducer from './Slices/blogSlice'
import eventsReducer from './Slices/eventsSlice'
import testimonialsReducer from './Slices/testimonialsSlice'
import subscribersReducer from './Slices/newsletterSlice'
import contactUsReducer from './Slices/contactusSlice'
import tagsReducer from './Slices/tagsSlice'
import unitsReducer from './Slices/unitsSlice'
import taxsReducer from './Slices/taxSlice'
import hsnsReducer from './Slices/hsnSlice'
import categoriesReducer from './Slices/categoriesSlice'
import sizesReducer from './Slices/sizeSlice'
import colorReducer from './Slices/colorSlice'
import inventoryReducer from './Slices/inventorySlice'
import addressReducer from './Slices/addressSlice'
import ordersReducer from './Slices/orderSlice'
import reviewsReducer from './Slices/reviewSlice'

export default configureStore({
    reducer: {
        auth: authReducer,
        tagsData: tagsReducer,
        unitsData: unitsReducer,
        taxsData: taxsReducer,
        hsnsData: hsnsReducer,
        categoriesData: categoriesReducer,
        sizesData: sizesReducer,
        colorsData: colorReducer,
        inventoriesData: inventoryReducer,
        addresses: addressReducer,
        ordersData: ordersReducer,
        productsData: productsReducer,
        blogsData: blogsReducer,
        eventsData: eventsReducer,
        testimonialsData: testimonialsReducer,
        subscribersData: subscribersReducer,
        contactusData: contactUsReducer,
        reviewsdata: reviewsReducer,


    }
})